module.exports = __webpack_public_path__ + "img/35.bf0c7a61.jpg";